export default __webpack_public_path__ + "static/media/translate_logo.cff58723.svg";